<div>
  <sb-card>
    <div card-header></div>
    <div card-header-more class="tw-flex tw-justify-end tw-items-center">
      <sb-threeway-toggle-button [disabled]="loading" [(model)]="productiveToggle" class="ml-1 mr-1 mb-1">
        {{ 'lang.globals.productive' | translate }}
      </sb-threeway-toggle-button>
      <sb-comp-dropdown-select
        [singleSelectMode]="true"
        (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
        (selectedDataEmitter)="update($event, 'PLAYER_CULLS')"
        *ngPermissions="permissionService.Permission.cull_list" [dropDownDatatype]="'PLAYER_CULLS'"
        [inputData]="playerCulls" [msOptions]="msPlayerOptions"
        [selectedInputData]="filteredCull ? [filteredCull] : []" [showColumnIcon]="false"
        [showSubmit]="false">
      </sb-comp-dropdown-select>
      <sb-local-date-range-input [from]="from" [till]="till" [showSubmit]="true" class="tw-mx-2"
                                 (dateChange)="handleDateChange($event)"></sb-local-date-range-input>
      <button class="btn btn-primary" (click)="requestDebounced()" type="button">{{ 'lang.reporting.getData' | translate }}</button>
    </div>
    <div card-body>
      @if (!loading) {
        @if (noDataFound) {
          <div class="tw-flex tw-items-center tw-justify-center">
            <img height="280" src="./assets/img/notFoundWhitelabel.png" alt="No Data"/>
            <div style="margin-bottom: 15px; margin-left: 10px">
              <h1>{{ 'lang.globals.noDataFound' | translate }}</h1>
              <h4>{{ 'lang.reporting.noDataDescription' | translate }}</h4>
            </div>
          </div>

        } @else {
          <div class="tw-sticky tw-top-[80px] tableBg tw-z-[4] tw-pt-6">
            <div class="tw-flex tw-items-center tw-justify-between">
              <div class="tw-flex tw-items-center">
                <button [ngClass]="{'active' : selectedDataset?.id != null}" sb-button-secondary [iconButton]="true" class="tw-mr-2"
                        (click)="selectDataset()" icon="undo">
                </button>
                <h3 class="tw-m-0">{{ selectedDataset?.name }}</h3>
              </div>
              <div class="tw-flex tw-gap-5">
                <div>
                  <label for="type">{{ 'lang.globals.type' | translate }}</label>
                  <select id="type" class="tw-ml-2"
                          [ngModel]="selectedDisplayType"
                          (ngModelChange)="adjustDisplayType($event)">
                    @for (option of displayableTypesSoV; track option) {
                      <option [ngValue]="option">{{ ('lang.globals.' + option.toLowerCase()) | translate }}</option>
                    }
                  </select>
                </div>
                <div>
                  <label for="threshold">{{ 'lang.globals.threshold' | translate }}</label>
                  <input type="number" id="threshold" step="0.1" min="0" max="100" class="tw-ml-2 tw-w-18 tw-text-right"
                         [ngModel]="threshold"
                         (ngModelChange)="adjustThreshold($event)"/>
                </div>
              </div>
            </div>
            <div class="tw-flex tw-w-full">
              <sb-chart #lineChart chartType="lineChart" class="tw-w-full" [chartData]="hourData"></sb-chart>
              <sb-chart #pieChart chartType="pieChart" [chartData]="pieChartData"></sb-chart>
            </div>
          </div>

          <table class="table">
            <thead class="tw-sticky tw-top-[329px] tw-z-[4]">
            <tr>
              <th class="tw-flex">
                <a (click)="toggleExpandAll()" class="tw-text-sbBlue-600 tw-mr-2 icon-in-btn tw-cursor-pointer">
                  @if (isAllExpanded) {
                    <sb-icon icon="chevronDown"></sb-icon>
                  } @else {
                    <sb-icon icon="chevronRight"></sb-icon>
                  }
                </a>
                {{ 'nav.content' |translate }}
              </th>
              <th>{{ 'lang.globals.type' | translate }}</th>
              <th>{{ 'lang.globals.playouts' | translate }}</th>
              <th>{{ 'lang.globals.percentage' | translate }}</th>
              <th>{{ 'lang.globals.overallPercentage' | translate }}</th>
              <th>{{ 'lang.globals.locations' | translate }}</th>
              <th>{{ 'lang.globals.devices' | translate }}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngTemplateOutlet="recursiveListTemplate; context:{ data: companies, depth: 0, isLast: false}">
            </ng-container>
            </tbody>
          </table>
        }

      } @else if (loading && noDataFound !== null) {
        <sb-loading-spinner></sb-loading-spinner>
      } @else {
        <div class="tw-text-3xl tw-py-20 tw-flex tw-justify-center">{{ 'lang.globals.selectAndLoad' | translate }}</div>
      }
    </div>
  </sb-card>
</div>


<ng-template #recursiveListTemplate let-data="data" let-depth="depth" let-isLast="isLast">
  @let map = identityType(data);
  <ng-container *ngFor="let item of map; last as last">
    <tr>
      <td class="tw-flex tw-items-center">
        <div class="tw-mr-2">
          <a (click)="toggleShowChildren(item.internalId, item)" class="cursor-pointer">
            <sb-icon *ngIf="item.subTree && showSubTree.has(item?.internalId)"
                     [style.margin-left.px]="depth ?? 0"
                     [icon]="'chevronDown'" class="icon-in-btn"
            ></sb-icon>
            <sb-icon *ngIf="item.subTree && !showSubTree.has(item?.internalId)"
                     [style.margin-left.px]="depth ?? 0"
                     [icon]="'chevronRight'" class="icon-in-btn"
            ></sb-icon>
          </a>
          <sb-icon *ngIf="!(item.subTree)" [style.margin-left.px]="depth ?? 0"
                   [icon]="'chevronRight'" style="opacity: 0;"></sb-icon>
        </div>
        @if (item.type === ('lang.globals.motives'|translate) || item.type === ('lang.globals.mediumGroup'|translate)) {

          <sb-comp-image-name-wrapper [medium]="item.medium" [customHeight]="'40px'" [customWidth]="'40px'" [thumbnailSize]="'XS'">
            <div firstLine>
              <ng-container *ngTemplateOutlet="nameTemplate;  context:{ itemValue: item, depth: depth}"></ng-container>
            </div>
            <span secondLine>{{ item.secondLine }}</span>
            <span thirdLine>{{ item.thirdLine }}</span>
          </sb-comp-image-name-wrapper>
        } @else {
          <ng-container *ngTemplateOutlet="nameTemplate;  context:{ itemValue: item, depth: depth}"></ng-container>
        }
      </td>
      <td>{{ item.type }}</td>
      <td>{{ Number(item.playouts.toFixed(0)) |sbNumberFormat }}{{ selectedDisplayType === 'Time' ? 's' : '' }}</td>
      <td>{{ item.percentage }}%</td>
      <td>{{ item.overallPercentage }}%</td>
      <td>{{ item.playerAggregation?.max?.locations }}</td>
      <td>{{ item.playerAggregation?.max?.screens }}</td>
      <td>
        <button *ngIf="item.subTree" [ngClass]="{'active' : selectedDataset.id == item.internalId}" sb-button-secondary [iconButton]="true"
                (click)="selectDataset(item)" icon="lineChart"></button>
      </td>
    </tr>
    <ng-container *ngIf="item.subTree && showSubTree.has(item?.internalId)">
      <ng-container *ngTemplateOutlet="recursiveListTemplate; context:{ data: item.subTree, depth: (depth ?? 0) + 25, isLast: last}">
      </ng-container>
    </ng-container>
    <tr *ngIf="last && !isLast">
      <td colspan="100"></td>
    </tr>
  </ng-container>
</ng-template>

<ng-template #nameTemplate let-item="itemValue" let-depth="depth">
  <div class="tw-size-5 tw-rounded-full tw-mx-2" [style.background-color]="item.color" *ngIf="depth === 0 "></div>
  <div [ngClass]="{'tw-italic': !item.id}" [ngbTooltip]="item.id? 'ID: '+item.id : ''"><span [innerHTML]="item.name | truncate: 50"></span>
  </div>
</ng-template>
